import { Module } from 'vuex-smart-module';
import NewRepairActions from './actions';
import NewRepairGetters from './getters';
import NewRepairMutations from './mutations';
import NewRepairState from './state';

export default new Module({
  state: NewRepairState,
  mutations: NewRepairMutations,
  actions: NewRepairActions,
  getters: NewRepairGetters,
});
